const state = {
  items: []
}

const getters = {
  getItems: state => state.items
}

const mutations = {
  UPDATE_ITEMS: (state, items) => {
    state.items = [ ...items ]
  }
}

const actions = {
  updateItems: ({ commit }, items) => {
    commit('UPDATE_ITEMS', items)
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
